import { SVGObject } from "../svgobject";

export class SVGSymbol1 extends SVGObject{
    public drawObject():void{
		super.initObject();
        this.svg =`<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 20000303 Stylable//EN" "http://www.w3.org/TR/2000/03/WD-SVG-20000303/DTD/svg-20000303-stylable.dtd"[]><svg xmlns="http://www.w3.org/2000/svg" width="64px" height="64px" viewBox="0 0 999 874"><path style="fill:#f00" d="M166,790 l333,-582 0,-208 -499,874 999,0 -500,-874 0,208 333,582 -666,0z" /></svg>`
		super.fillGradients();
        super.drawObject();
    }
}